import { makeAutoObservable } from 'mobx'
import { Moment } from 'moment'
import * as apiClient from 'src/utils/apiClient/webApplications'

type RegisterParams = Omit<apiClient.RegisterParams, 'moveInOn'> & {
  moveInOn: Moment
}

export default class WebApplicationStore {
  // Constructor ------------

  constructor() {
    makeAutoObservable(this)
  }

  // Actions ---------------

  getAccountTransferEditParams = async (params: apiClient.GetAccountTransferEditParamsParams) => {
    return await apiClient.getAccountTransferEditParams(params)
  }

  getCreditCardEditURL = async (params: apiClient.GetCreditCardEditURLParams) => {
    const { url } = await apiClient.getCreditCardEditURL(params)
    return url
  }

  register = async (params: RegisterParams) => {
    const { info } = await apiClient.register({
      ...params,
      moveInOn: params.moveInOn.format('YYYY-MM-DD'),
    })
    return info
  }
}
